import { Component, OnInit } from '@angular/core';
import { PDFDocumentProxy, PdfViewerModule } from 'ng2-pdf-viewer';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { FileSystemService } from '../../../../services/file-system.service';

@Component({
  selector: 'app-pdf-viewer',
  imports: [PdfViewerModule, DrawerModule, ButtonModule],
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.css'
})
export class PdfViewerComponent implements OnInit {
  src : string = "";
  outline: any[] = [];
  visible: boolean = false;

  constructor(private usdm: Usdm2Service, private fs: FileSystemService) {}

  async ngOnInit(): Promise<void> {
    await this.loadPdf();
  }

  async loadPdf() {
    const node = this.fs.rootNode.getNode(this.usdm.protocol!.path);
    if (node) {
      await node.getBlob().then((blob) => {
        if (blob) {
          this.src = URL.createObjectURL(blob);
        } else {
          this.src = "";
          console.warn('Failed to get blob for protocol:', node.path);
        }
      }).catch((error) => {
        console.error('Error getting blob for protocol:', error);
        this.src = "";
      });
    } else {
      this.src = "";
      console.log('No protocol available');
    }
  }

  afterLoadComplete (pdf: PDFDocumentProxy): void {
    pdf.getOutline().then((outline: any[]) => {
      this.outline = outline;
      console.log('Outline:', this.outline);
    });
  }
}
